module.exports = __webpack_public_path__ + "static/media/photo306.1b96ffd9.jpg";